import axios from 'axios';
import { getViewerAuthHeader } from './ViewerAuth';

export class GaleriaServices {
    getValuesServiceSerie(servicoImagem, studyUid) {
        let seriesAslDicom = [];
        const authHeader = getViewerAuthHeader();

        return axios.get(`${servicoImagem}/${studyUid}/getstudyimagens`, {
            headers: authHeader ? { 'Authorization': authHeader } : {}
        })
            .then(res => {
                res.data.instanceImage.forEach(obj => {
                    seriesAslDicom.push({
                        Serie: obj.serie,
                        Instances: obj.instances
                    });
                });
                return seriesAslDicom;
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    }
}